<div class="transfer-option-container">
  <ion-button
    class="button large primary"
    [ngClass]="font?.size" 
    (click)="openModal()">
    {{ affiliateTransferOptions?.title | translate }}
  </ion-button>
</div>
